(function () {
  "use strict";
  var root = document.documentElement;
  root.classList.add("vod-sig");
  function luminance(color) {
    var m = /rgba?\(([^)]+)\)/.exec(color || "");
    if (!m) return null;
    var p = m[1].split(",").map(function (n) { return parseFloat(n); });
    if (p.length > 3 && p[3] < 0.5) return null;
    return (0.2126 * p[0] + 0.7152 * p[1] + 0.0722 * p[2]) / 255;
  }
  function tagSections() {
    var pageLum = luminance(getComputedStyle(document.body).backgroundColor);
    if (pageLum === null) pageLum = 1;
    var sections = [].slice.call(document.querySelectorAll(".shopify-section"));
    var tones = sections.map(function (s) {
      var lum = luminance(getComputedStyle(s).backgroundColor);
      if (lum === null) {
        var inner = s.querySelector(".color-scheme-1, .color-scheme-2, .color-scheme-3, .gradient");
        lum = inner ? luminance(getComputedStyle(inner).backgroundColor) : null;
      }
      if (lum === null) lum = pageLum;
      return lum < 0.45 ? "dark" : "light";
    });
    sections.forEach(function (s, i) {
      s.setAttribute("data-vod-tone", tones[i]);
      var next = tones[i + 1];
      if (next && next !== tones[i]) s.setAttribute("data-vod-seam", "");
    });
  }
  function headerState() {
    var ticking = false;
    function apply() {
      root.classList.toggle("vod-scrolled", window.scrollY > 24);
      document.body.classList.toggle("vod-has-scrolled", window.scrollY > 16);
      ticking = false;
    }
    apply();
    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }, { passive: true });
  }
  function silenceAnnouncementBar() {
    if (!window.customElements || !customElements.get) return;
    var SC = customElements.get("slideshow-component");
    if (!SC || !SC.prototype || SC.prototype.__vodGuarded) return;
    var original = SC.prototype.applyAnimationToAnnouncementBar;
    if (typeof original !== "function") return;
    SC.prototype.applyAnimationToAnnouncementBar = function () {
      try { return original.apply(this, arguments); } catch (e) { return undefined; }
    };
    SC.prototype.__vodGuarded = true;
  }
  function boot() {
    try { silenceAnnouncementBar(); } catch (e) {}
    try { tagSections(); } catch (e) {}
    headerState();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", tagSections);
})();

